module.exports = __webpack_public_path__ + "img/easter_tour_mini_cover_3.4fabedbb.png";